import React, {Fragment, useRef, useState} from 'react';
import {useTheme} from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { Field} from 'react-final-form';
import {Select, Accordion} from '../../';
import Button from '@material-ui/core/Button';

export default function CompanyDecisionsSection(props){

  const theme=useTheme();


  return(
                    <Accordion
                      style={{width:'calc(100% + 40px)', marginLeft:'-20px'}}
                      open={(props.open_section=='custom_decisions')?true:false}
                      onChange={()=>{props.setOpenSection((props.open_section=='custom_decisions')?undefined:'custom_decisions')}}
                      content={[
                        {
                          title: (
                            <Typography style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'0px', marginBottom:'0px'}}><span style={{color:theme.palette.primary.main}}>{"Custom decisions: "}</span></Typography>
                          ),
                          content:(props.workspace==undefined || props.workspace.workspace_decisions.length==0)?
                          <div style={{width:'100%', height:'60px', display:'flex', justifyContent:'center', alignItems:'center'}}><Button color='secondary' onClick={()=>{window.location.href='/setup';}}>Add custom fields</Button></div>
                          :(
                            <Grid container style={{ marginTop: '-20px' }}>
                            {props.workspace.workspace_decisions.map(function(wd){
                              return(<Grid item xs={6} sm={4}><Select size='small' title={wd.name} variant='outlined' style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px', backgroundColor:'#f7f9fc'}} name={'company_decision_'+wd.id} select_data={[{id:'', name:''}, {id:0, name:'NO'}, {id:1, name:'A'}, {id:2, name:'B'}, {id:3, name:'C'}]}/></Grid>)
                            })}
                            </Grid>
                          ),
                        },
                      ]}
                    />
)
}
